import { message } from "ant-design-vue";
import axios from "axios";
axios.defaults.withCredentials = true; //允许跨域携带cookies
// require('../../mock/index')  //引入 mock 入口文件

var HOST = process.env.VUE_APP_HOST; // 本站点域名
var LOGIN_SERVER = process.env.VUE_APP_LOGIN_SERVER; // 登录跳转域名-信息服务中心
var APPS_SERVIER = process.env.VUE_APP_APPS_SERVIER; // 接口域名-信息服务中心接口
var MOCK = process.env.VUE_APP_MOCK;
// console.log("host", HOST);
// console.log('当前环境', process.env.NODE_ENV);
// console.log('当前环境', MOCK);
// console.log("process.env.VUE_APP_FLAG", process.env.VUE_APP_FLAG);

//请求发送拦截
axios.interceptors.request.use(
    (request) => {
        // if (process.env.NODE_ENV == 'production') {}
        return request;
    },
    function (error) {
        return Promise.reject(error);
    }
);

function handleFunc (res, url) {
    let codeStr = res.code + "";
    if (url.indexOf("/api/user/info") < 0) {
        if (
            codeStr != "2003" &&
            codeStr != "0000" &&
            codeStr != "2004" &&
            codeStr.indexOf("22") == -1 &&
            res.message != "成功"
        ) {
            message.error(res.message);
        }
    } else if (codeStr == "2001") {
        message.error(res.message);
        console.log(res);

        if (res.redirect) {
            window.open(`${res.redirect}`, "_self");
            return
        } else {
            window.open(`${APPS_SERVIER}/api/redirect?school_code=${localStorage.getItem("schoolCode")}&format=html&from=${window.location.href}`, "_self");
        }
    } else if (codeStr == "2403") {
        window.open(`${window.location.origin}/${localStorage.getItem("schoolCode")}/noauth`, "_self");
    }
}

const request = (method, url, params) => {
    let result = url
    if (MOCK == 'true') {
        const index = url.indexOf('/api');
        result = url.substring(index);
    }
    if (method == "post") {
        return axios
            .post(result, params)
            .then((res) => res.data)
            .then((res) => {
                handleFunc(res, result);
                return res;
            });
    } else if (method == "get") {
        return axios
            .get(result, { params })
            .then((res) => res.data)
            .then((res) => {
                handleFunc(res, result);
                return res;
            });
    }
};

export default {
    HOST: HOST,
    LOGIN_SERVER: LOGIN_SERVER,
    APPS_SERVIER: APPS_SERVIER,
    // 信息服务中心 - 获取院校是否开通应用
    getAppsLoginInfo (params) {
        return request("get", APPS_SERVIER + "/api/login/info", params);
    },
    // 信息服务中心 - 退出登录
    postAppsLogout (params) {
        return request("post", APPS_SERVIER + "/api/logout", params);
    },
    // 获取用户信息
    getAppsUserInfo (params) {
        return request("get", HOST + "/api/user/info", params);
    },
    // 信息服务中心 - 获取学校信息
    getAppsSchoolInfo (params) {
        return request('get', APPS_SERVIER + '/api/login/info', params)
    },
    // 获取活动列表
    getCenterActivity (params) {
        return request("get", HOST + "/api/center/train/activity", params);
    },
    // 获取班级详情
    getCenterActivityClasses (params, query) {
        return request("get", HOST + `/api/center/train/activity/classes/${query}`, params);
    },
    // 获取活动班级列表
    getActivityClassesMember (params) {
        return request("get", HOST + `/api/center/train/activity/classes/member`, params);
    },
    // 获取活动成绩详情
    getTrainScore (params) {
        return request("get", HOST + `/api/center/train/score`, params);
    },
    // 获取加入班级记录
    getJoinRecord (params) {
        return request("get", HOST + `/api/center/train/activity/classes`, params);
    },
    //邀请码获取班级详情
    getclassInfoForCode (params) {
        return request("get", HOST + `/api/center/train/activity/classes/access/${params.code}`, params);
    },
    //加入班级
    postJoinClass (params) {
        return request("post", HOST + `/api/center/train/activity/classes`, params);
    },
    // 获取活动详情
    getCenterActivityDetail (params) {
        return request("get", HOST + `/api/center/train/activity/${params.id}`)
    },
    // 获取课程章节列表
    getCenterChapter (params) {
        return request("get", HOST + "/api/center/train/course/chapter", params)
    },
    // 获取任务列表
    getCenterTask (params) {
        return request("get", HOST + "/api/center/train/course/task", params)
    },
    // 获取任务数据
    getCenterTaskData (params) {
        return request("get", HOST + `/api/center/train/course/task/${params.code}`, params)
    },
    // 任务2.悟思政之韵-虚拟展厅云游-数字展馆学习 已学习提交
    sutmitT002 (params) {
        return request("get", HOST + "/api/center/train/hall/log/add", params)
    },
    // 任务3.悟思政之韵-虚拟展厅云游-数字展馆学习 已学习提交
    sutmitT003 (params) {
        return request("get", HOST + "/api/center/train/study/hub/log/add", params)
    },
    // 任务4.结思政之果-答”思政小测“-试题作答
    sutmitT004 (params) {
        return request("post", HOST + "/api/center/train/question/log", params)
    },
    // 任务5/6/7提交 传入code区分
    submitT005 (params) {
        return request("post", HOST + `/api/center/train/work/${params.code}`, params)
    },
    // 任务6.结思政之果-传”点位打卡“ -实践基地列表
    getCenterT006Hub (params) {
        return request("get", HOST + "/api/center/train/course/study/hub", params)
    },
    // 班级成员列表
    getCenterClassMember (params) {
        return request("get", HOST + `/api/center/train/work/member`, params)
    },
    // 作业附件下载 
    getAttachmentDownload (params) {
        return request("get", HOST + "/api/center/train/work/attachment/download", params)
    },
    // 课程资源下载
    getCourseDownload (params) {
        return request("get", HOST + "/api/center/train/course/resource/download", params)
    },
    // 教师端 - 获取活动列表
    getSchoolActivityData (params) {
        return request("get", HOST + "/api/school/train/activity", params)
    },
    // 教师端 - 创建活动
    postSchoolActivity (params) {
        return request("post", HOST + "/api/school/train/activity", params)
    },
    // 教师端 - 取实践学期
    getSchoolActivityTerm (params) {
        return request("get", HOST + "/api/school/train/term", params)
    },
    // 教师端 - 课程章节列表（筛选项）
    getSchoolTrainChapter (params) {
        return request("get", HOST + "/api/school/train/course/chapter", params)
    },
    // 教师端 - 课程列表（筛选项）
    getSchoolTrainCourse (params) {
        return request("get", HOST + "/api/school/train/course", params)
    },
    // 教师端 - 取作业详情
    getSchoolWorkDetail (params) {
        return request("get", HOST + `/api/school/train/work/${params.task_id}/${params.id}`, params)
    },
    // 教师端 - 阅作业
    postWorkScore (params) {
        return request("post", HOST + `/api/school/train/work/${params.task_id}/${params.work_id}`, params)
    },
    // 教师端 - 获取任务作业列表
    getSchoolTaskWorkList (params) {
        return request("get", HOST + `/api/school/train/work/${params.task_id}`, params)
    },
    // 教师端 - 获取任务作业 - 导出成绩
    getSchoolTaskExportScore (params) {
        return request("get", HOST + `/api/school/train/work/${params.task_id}/export_score`, params)
    },
    // 教师端 - 获取任务作业 - 导出附件
    getSchoolTaskExportAttach (params) {
        return request("get", HOST + `/api/school/train/work/${params.task_id}/export_attach`, params)
    },
    // 教师端 - 获取任务作业 - 下载附件
    getSchoolTaskDownAttach (params) {
        return request("get", HOST + `/api/school/train/work/${params.task_id}/download_attach`, params.data)
    },
    // 教师端 - 获取课程资源列表
    getCourseResource (params) {
        return request("get", HOST + "/api/school/train/course/resource", params);
    },
    // 教师端 - 获取课程数字展馆列表
    getCourseHall (params) {
        return request("get", HOST + "/api/school/train/course/hall", params);
    },
    // 教师端 - 获取课程实验基地列表
    getCourseStudyHub (params) {
        return request("get", HOST + "/api/school/train/course/study/hub", params);
    },
    // 教师端 - 实验基地/数字展馆 分类列表（筛选项）
    getSchoolCategory (params) {
        return request("get", HOST + "/api/school/train/category", params);
    },
    // 教师端 - 获取课程试题列表
    getCourseQuestion (params) {
        return request("get", HOST + "/api/school/train/course/question", params);
    },
    // 教师端 - 获取课程试题详情
    getCourseQuestionDetail (params) {
        return request("get", HOST + "/api/school/train/course/question/" + params.id, params.data);
    },

    // 教师端 - 系统管理 - 获取用户列表
    getSchoolManageUser (params) {
        return request("get", HOST + "/api/school/manage/user", params);
    },
    // 教师端 - 系统管理 - 用户添加
    addSchoolManageUser (params) {
        return request("post", HOST + "/api/school/manage/user", params);
    },
    // 教师端 - 系统管理 - 用户编辑、删除
    editSchoolManageUser (params) {
        return request("post", HOST + "/api/school/manage/user/" + params.id, params.data);
    },
    // 教师端 - 系统管理 - 用户详情
    getSchoolManageUserInfo (params) {
        return request("get", HOST + "/api/school/manage/user/" + params.id, params.data);
    },
    // 教师端 - 系统管理 - 用户查询
    getSchoolManageUserSearch (params) {
        return request("get", HOST + "/api/school/manage/user/search", params);
    },
    // 教师端 - 系统管理 - 获取学生列表 
    getSchoolStudent (params) {
        return request("get", HOST + "/api/school/student", params);
    },
    // 教师端 - 系统管理 - 学生重置密码 
    resetSchoolStudentPassword (params) {
        return request("post", HOST + "/api/school/student/password", params);
    },
    // 教师端 - 系统管理 - 学生添加
    addSchoolStudent (params) {
        return request("post", HOST + "/api/school/student", params);
    },
    // 教师端 - 系统管理 - 学生编辑、删除
    editSchoolStudent (params) {
        return request("post", HOST + "/api/school/student/" + params.id, params.data);
    },
    // 教师端 - 系统管理 - 学生详情
    getSchoolStudentInfo (params) {
        return request("get", HOST + "/api/school/student/" + params.id, params.data);
    },
    // 教师端 - 系统管理 - 学生查询
    getSchoolStudentSearch (params) {
        return request("get", HOST + "/api/school/student/search", params);
    },
    // 教师端 - 系统管理 - 学生导入2
    importSchoolStudent (params) {
        return request("post", HOST + "/api/school/student/import", params);
    },

    // 教师端 - 活动管理 - 班级列表
    getSchoolActivityClasses (params) {
        return request("get", HOST + "/api/school/train/activity/classes", params);
    },
    // 教师端 - 活动管理 - 班级添加
    addSchoolActivityClasses (params) {
        return request("post", HOST + "/api/school/train/activity/classes", params);
    },
    // 教师端 - 活动管理 - 班级详情
    getSchoolActivityClassesInfo (params) {
        return request("get", HOST + "/api/school/train/activity/classes/" + params.id, params.data);
    },
    // 教师端 - 活动管理 - 班级编辑、删除
    editSchoolActivityClasses (params) {
        return request("post", HOST + "/api/school/train/activity/classes/" + params.id, params.data);
    },
    // 教师端 - 活动管理 - 班级列表 - 班级学生列表
    getSchoolClassesMember (params) {
        return request("get", HOST + "/api/school/train/activity/classes/member", params);
    },
    // 教师端 - 活动管理 - 班级列表 - 班级学生删除
    delSchoolClassesMember (params) {
        return request("post", HOST + "/api/school/train/activity/classes/member/" + params.id, params.data);
    },
    // 教师端 - 活动管理 - 班级列表 - 班级学生 - 从学生库选择
    chooseSchoolClassesMember (params) {
        return request("post", HOST + "/api/school/train/activity/classes/member", params);
    },
    // 教师端 - 活动管理 - 实践成绩汇总 - 成绩列表
    getSchoolActivitySummary (params) {
        return request("get", HOST + "/api/school/train/score", params);
    },
    // 教师端 - 活动管理 - 活动详情
    getSchoolActivityDetail (params) {
        return request("get", HOST + `/api/school/train/activity/${params.id}`)
    },
    // 教师端 - 活动管理 - 删除活动(delete)/更新活动(put)
    updateSchoolActivity (params) {
        return request("post", HOST + `/api/school/train/activity/${params.id}`, params)
    },
    // 腾讯云上传附件签名
    getTencentSign (params) {
        return request("get", HOST + "/api/tencent/vod/sign/vod", params);
    },
    // 腾讯云点播修改时长
    setTencentTime (params) {
        return request("get", HOST + "/api/tencent/vod/modify/vod", params);
    },
    // 任务1.品思政之味-线上自主学习-视频资源播放
    getSteponeVideo (params) {
        return request("get", HOST + `/api/center/train/course/resource/${params.id}/play`, params);
    },
    // 任务1.品思政之味-线上自主学习-视频资源学习
    getSteponeVideoLearn (params) {
        return request("get", HOST + `/api/center/train/learn/log/add`, params);
    },

    // 学生端 - 实践案例 - 优秀案例列表
    getCasesList (params) {
        return request("get", HOST + "/api/center/train/cases", params)
    },
    // 学生端 - 实践案例 - 优秀案例详情
    getCasesDetail (params) {
        return request("get", HOST + `/api/center/train/cases/${params.id}`, params);
    },
    // 教师端 - 实践案例 - 案例台账列表
    getSchoolTrainCases (params) {
        return request("get", HOST + `/api/school/train/cases/${params.id}`, params.data);
    },
    // 教师端 - 实践案例 - 优秀案例列表
    getSchoolExcellentCases (params) {
        return request("get", HOST + `/api/school/train/cases`, params);
    },
    // 教师端 - 实践案例 - 创建优秀案例
    postSchoolTrainCases (params) {
        return request("post", HOST + `/api/school/train/cases`, params);
    },
    // 教师端 - 实践案例 - 优秀案例详情
    getSchoolCasesDetails (params) {
        return request("get", HOST + `/api/school/train/cases/${params.id}`, params.data);
    },
    // 教师端 - 实践案例 - 优秀案例状态切换
    postSchoolCasesStatus (params) {
        return request("post", HOST + `/api/school/train/cases/status/${params.id}`, params.data);
    },
    // 教师端 - 实践案例 - 优秀案例编辑、删除
    putSchoolTrainCases (params) {
        return request("post", HOST + `/api/school/train/cases/${params.id}`, params.data);
    },
    // 腾讯云点播媒体详情
    getTencentVodInfo (params) {
        return request("get", HOST + `/api/tencent/vod/info/vod`, params);
    },

    // 教师端 - 实践案例 - 优秀案例视频导出
    getSchoolCasesExport (params) {
        return request("get", HOST + `/api/school/train/cases/export_attach`, params)
    },

    // 教师端 - 实践案例 - 优秀案例视频下载
    getSchoolCasesDownload (params) {
        return request("get", HOST + `/api/school/train/cases/download_attach`, params)
    },
    // 教师端 活动数据统计列表
    getAnalyticsStatistics (params) {
        return request("get", HOST + `/api/school/train/stat`, params)
    },
    // 教师端 活动数据统计
    getAnalyticsInfo (params) {
        return request("get", HOST + `/api/school/train/stat/${params.id}`,)
    },
    // 红色金融实践 - 实践班级
    gethsjrClass (params) {
        return request("get", HOST + `/api/school/train/venue/classes`, params)
    },
    // 红色金融实践 - 实践班级详情
    gethsjrClassInfo (params) {
        return request("get", HOST + `/api/school/train/venue/classes/` + params.id)
    },
    // 红色金融实践 - 添加实践班级
    addhsjrClass (params) {
        return request("post", HOST + "/api/school/train/venue/classes", params);
    },
    // 红色金融实践 - 班级编辑、删除
    edithsjrClass (params) {
        return request("post", HOST + "/api/school/train/venue/classes/" + params.id, params.data);
    },
    // 红色金融实践 - 班级学生 
    gethsjrStudent (params) {
        return request("get", HOST + `/api/school/train/venue/classes/member`, params)
    },
    // 红色金融实践 - 删除班级学生
    delhsjrStudent (params) {
        return request("post", HOST + `/api/school/train/venue/classes/member/` + params.id, params.data)
    },
    // 红色金融实践 - 选择班级学生
    choosehsjrStudent (params) {
        return request("post", HOST + `/api/school/train/venue/classes/member`, params)
    },
    // 红色金融实践 - 获取班级评阅已经提交
    gethsjrClassReview (params) {
        return request("get", HOST + `/api/school/train/venue/story`, params)
    },
    // 红色金融实践 - 获取班级评阅未提交
    gethsjrClassReviewUndo (params) {
        return request("get", HOST + `/api/school/train/venue/story/undo`, params)
    },
    // 教师端 - 红色金融实践 - 导出附件
    getsjrClassReviewExportAttach (params) {
        return request("get", HOST + `/api/school/train/venue/story/export_attach`, params)
    },
    // 教师端 - 红色金融实践 - 下载附件
    gethsjrClassReviewAttach (params) {
        return request("get", HOST + `/api/school/train/venue/story/download_attach`, params.data)
    },
    // 红色金融实践 - 故事详情
    gethsjrClassReviewInfo (params) {
        return request("get", HOST + `/api/school/train/venue/story/` + params.id, params.data)
    },
    // 红色金融实践 - 故事评分
    setscoreSubmit (params) {
        return request("post", HOST + `/api/school/train/venue/story/approve`, params)
    },

    // 红色金融实践 - 设置隐藏公开
    setStoryStatus (params) {
        return request("post", HOST + `/api/school/train/venue/story/status`, params)
    },
    // 红色金融实践 - 场馆类型
    getStadiumType (params) {
        return request("get", HOST + `/api/school/train/venue/category`, params)
    },
    // 红色金融实践 - 场馆类型详情
    getStadiumTypeInfo (params) {
        return request("get", HOST + `/api/school/train/venue/category/` + params.id)
    },
    // 红色金融实践 - 添加场馆类型
    addStadiumType (params) {
        return request("post", HOST + `/api/school/train/venue/category`, params)
    },
    // 红色金融实践 - 编辑删除场馆类型
    editStadiumType (params) {
        return request("post", HOST + `/api/school/train/venue/category/` + params.id, params.data)
    },
    // 红色金融实践 - 场馆旧址列表
    getStadiumAddress (params) {
        return request("get", HOST + `/api/school/train/venue`, params)
    },
    // 红色金融实践 - 添加场馆旧址
    addStadiumAddress (params) {
        return request("post", HOST + `/api/school/train/venue`, params)
    },
    // 红色金融实践 - 场馆旧址详情
    getStadiumAddressInfo (params) {
        return request("get", HOST + `/api/school/train/venue/` + params.id)
    },
    // 红色金融实践 -  编辑删除场馆旧址
    editStadiumAddress (params) {
        return request("post", HOST + `/api/school/train/venue/` + params.id, params.data)
    },
    // 红色金融实践 - 文物列表
    getSartifact (params) {
        return request("get", HOST + `/api/school/train/venue/art`, params)
    },
    // 红色金融实践 - 添加文物
    addSartifact (params) {
        return request("post", HOST + `/api/school/train/venue/art`, params)
    },
    // 红色金融实践 - 文物详情
    getSartifactInfo (params) {
        return request("get", HOST + `/api/school/train/venue/art/` + params.id, params.data)
    },
    // 红色金融实践 -  编辑删除文物
    editSartifact (params) {
        return request("post", HOST + `/api/school/train/venue/art/` + params.id, params.data)
    },
    // 红色金融实践 - 人物列表
    getCharacter (params) {
        return request("get", HOST + `/api/school/train/venue/person`, params)
    },
    // 红色金融实践 - 添加人物
    addCharacter (params) {
        return request("post", HOST + `/api/school/train/venue/person`, params)
    },
    // 红色金融实践 - 人物详情
    getCharacterInfo (params) {
        return request("get", HOST + `/api/school/train/venue/person/` + params.id, params.data)
    },
    // 红色金融实践 -  编辑删除人物
    editCharacter (params) {
        return request("post", HOST + `/api/school/train/venue/person/` + params.id, params.data)
    },
    // 红色金融实践 - 展厅列表
    getHall (params) {
        return request("get", HOST + `/api/school/train/venue/hall`, params)
    },
    // 红色金融实践 - 添加展厅
    addHall (params) {
        return request("post", HOST + `/api/school/train/venue/hall`, params)
    },
    // 红色金融实践 - 展厅详情
    getHallInfo (params) {
        return request("get", HOST + `/api/school/train/venue/hall/` + params.id, params.data)
    },
    // 红色金融实践 -  编辑删除展厅
    editHall (params) {
        return request("post", HOST + `/api/school/train/venue/hall/` + params.id, params.data)
    },



};
